import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

const LogoutButton = (): JSX.Element => {
    const { logout } = useAuth0();
    const { t } = useTranslation();

    const handleLogout = () => {
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    return (
        <button className='btn btn-danger' onClick={handleLogout}>
            {t('log_out')}
        </button>
    );
};

export default LogoutButton;
